import { EyeIcon } from '@heroicons/react/24/solid'

export default ({title, file}) => {
  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    window.open(file.url, '_blank')
  }
  
  return (
    <button 
      onClick={handleClick}
      className="btn btn-xs btn-ghost btn-square p-1 hover:bg-primary-400"
      title={`Voir ${title}`} aria-label={`Voir ${title}`}
    >
      <EyeIcon className="h-4 w-4"/>
    </button>
  )
}